import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersistence from 'vuex-persist'

Vue.use(Vuex)

const initialState = {
    name: null,
    score: 0,
    currentTrivia: 1,
    currentAnswer: {},
    isAuthenticated: false,
    isLoading: false
}

export default new Vuex.Store({
    state: initialState,
    mutations: {
        addName: (state, payload) => {
            state.name = payload.name
        },
        incrementScore: (state, payload) => {
            state.score = state.score + payload.score
        },
        resetStore: (state) => {
            Object.assign(state, initialState)
        },
        setAuthenticated: (state, payload) => {
            state.isAuthenticated = payload.status
        },
        setCurrentTrivia: (state, payload) => {
            state.currentTrivia = payload.currentTrivia
        },
        setCurrentAnswer: (state, payload) => {
            state.currentAnswer = payload.answer
        },
        setLoading: (state, payload) => {
            state.isLoading = payload
        }
    },
    actions: {
        addName: (context, payload) => {
            context.commit('addName', payload)
        },
        incrementScore: (context, payload) => {
            context.commit('incrementScore', payload)
        },
        resetStore: (context) => {
            context.commit('resetStore')
        },
        setAuthenticated: (context, payload) => {
            context.commit('setAuthenticated', payload)
        },
        setCurrentTrivia: (context, payload) => {
            context.commit('setCurrentTrivia', payload)
        },
        setCurrentAnswer: (context, payload) => {
            context.commit('setCurrentAnswer', payload)
        },
        setLoading: (context, payload) => {
            context.commit('setLoading', payload)
        }
    },
    plugins: [new VuexPersistence().plugin]
})